import cn from "classnames";
import { HTMLProps } from "react";
import s from "../WithSidebar.module.scss";

const Body = ({ children }: HTMLProps<HTMLDivElement>) => (
  <section className={cn(s.body, s.column)}>{children}</section>
);

export default Body;
